"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Map = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _map_loader = _interopRequireDefault(require("./map_loader"));

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _map = require("./map.style");

var _useReverseGeoCode3 = require("../../utils/useReverseGeoCode");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// import MapMarkerIcon from '../../svg/map-marker.svg';
// import SenderMapMarkerIcon from '../../svg/map-marker-sender.svg';
// import ReceiverMapMarkerIcon from '../../svg/map-marker-receiver.svg';
// const maps = [];
var Map = function Map(props) {
  var style = props.style,
      options = props.options,
      onInit = props.onInit,
      defaultCoords = props.defaultCoords,
      getMapData = props.getMapData,
      type = props.type;
  var randomId = (0, _react.useRef)(Date.now() * Math.random() * 1000000);
  var mapRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPoint = _useState2[0],
      setSelectedPoint = _useState2[1];

  var _useReverseGeoCode = (0, _useReverseGeoCode3.useReverseGeoCode)(),
      _useReverseGeoCode2 = _slicedToArray(_useReverseGeoCode, 3),
      getAddress = _useReverseGeoCode2[0],
      response = _useReverseGeoCode2[1],
      error = _useReverseGeoCode2[2];

  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _map.useStyles)();
  var defaultStyle = {
    width: "100%",
    height: "100%",
    margin: 0,
    padding: 0,
    background: "#eee"
  };
  var defaultOptions = {
    key: "web.4gBekenSDVOVlLPVFKKptWgRmaSH0ZZx4rmfzKsg",
    maptype: "dreamy-gold",
    poi: true,
    traffic: false,
    center: [35.699739, 51.338097],
    zoom: 14
  };

  var updateMap = function updateMap(point, reserve) {
    // let mapObject = null;
    // for (let i = maps.length; i--;) if(maps[i].id === randomId.current) mapObject = maps[i];
    if (mapRef.current) {
      mapRef.current.marker.setLatLng(point);
      mapRef.current.instance.setView(point, 16, {
        animate: true
      });
      if (reserve) getAddress(point);
      setSelectedPoint(point);
    }
  };

  (0, _react.useEffect)(function () {
    (0, _map_loader["default"])({
      onLoad: function onLoad() {
        var map = new window.L.Map("".concat(randomId.current), _objectSpread(_objectSpread({}, defaultOptions), options)); // const icon = new L.Icon({
        //   iconUrl: type === 'sender' ? SenderMapMarkerIcon : type === 'receiver' ? ReceiverMapMarkerIcon : MapMarkerIcon,
        //   iconRetinaUrl: type === 'sender' ? SenderMapMarkerIcon : type === 'receiver' ? ReceiverMapMarkerIcon : MapMarkerIcon,
        //   iconAnchor: null,
        //   popupAnchor: null,
        //   shadowUrl: null,
        //   shadowSize: null,
        //   shadowAnchor: null,
        //   iconSize: new L.Point(50, 65),
        // });
        // let marker = window.L.marker([35.699739, 51.338097], {icon}).addTo(map);

        var marker = window.L.marker([35.699739, 51.338097]).addTo(map);
        map.on('click', function (e) {
          updateMap([e.latlng.lat, e.latlng.lng], true);
        }); // maps.push({id: randomId.current, instance: map, marker: marker});

        mapRef.current = {
          id: randomId.current,
          instance: map,
          marker: marker
        };
        if (onInit) onInit(window.L, map, marker);
      },
      onError: function onError() {
        console.error("Maps Error: This page didn't load Maps correctly");
      }
    });
  }, []);
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      if (defaultCoords.length > 0) {
        updateMap(defaultCoords, false);
      }
    }, 300);
  }, [defaultCoords]);
  (0, _react.useEffect)(function () {
    if (response) if (getMapData) getMapData({
      coords: selectedPoint,
      address: response
    });
  }, [response]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: randomId.current,
    style: _objectSpread(_objectSpread({}, defaultStyle), style)
  });
};

exports.Map = Map;
Map.propTypes = {
  /** Function to get map data after each point is selected */
  getMapData: _propTypes["default"].func.isRequired,

  /** Array containing two number [lat,lng] to show default location */
  defaultCoords: _propTypes["default"].array,

  /** type for sender or receiver marker, if nothing pass, without text marker will be shown */
  type: _propTypes["default"].oneOf(['sender', 'receiver'])
};